import { Navigate, useLocation } from 'react-router-dom';
import { NewPasswordForm, isFailedAuthResult } from '../features/Login';

export function NewPassword() {
  const state: unknown = useLocation().state;

  if (!isFailedAuthResult(state)) {
    return <Navigate to="/login" />;
  }

  return <NewPasswordForm session={state.session} email={state.email} />;
}
